import React from "react";

const WhatsAppSVG = () => {
  return (
    <svg
    className="WhatsAppSVG"
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g id="Layer 2">
        <g id="09.whatsapp">
          <path
            id="background"
            d="M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z"
            fill="#62B958"
          />
          <g id="icon">
            <path
              id="Vector"
              d="M35.0816 13.4182C32.5846 10.8962 29.2686 9.34964 25.7317 9.05731C22.1948 8.76498 18.6699 9.74618 15.7927 11.8239C12.9155 13.9016 10.8756 16.9391 10.0407 20.3885C9.20586 23.8379 9.63112 27.472 11.2398 30.6354L9.66068 38.3018C9.64429 38.3781 9.64383 38.457 9.65931 38.5335C9.6748 38.6099 9.7059 38.6824 9.75068 38.7463C9.81627 38.8434 9.90989 38.918 10.0191 38.9604C10.1282 39.0028 10.2477 39.0109 10.3616 38.9836L17.8752 37.2027C21.0298 38.7706 24.6383 39.1685 28.0586 38.3256C31.479 37.4827 34.4894 35.4537 36.5542 32.5995C38.619 29.7454 39.6042 26.2512 39.3345 22.7389C39.0649 19.2265 37.5578 15.9237 35.0816 13.4182ZM32.7389 32.1163C31.0112 33.8392 28.7865 34.9764 26.3782 35.3678C23.97 35.7593 21.4996 35.3851 19.3152 34.2982L18.2679 33.78L13.6616 34.8709L13.6752 34.8136L14.6298 30.1772L14.117 29.1654C13.0009 26.9734 12.6072 24.4845 12.9923 22.055C13.3773 19.6256 14.5214 17.3803 16.2607 15.6409C18.4461 13.4562 21.4097 12.2289 24.4998 12.2289C27.5899 12.2289 30.5535 13.4562 32.7389 15.6409C32.7575 15.6622 32.7775 15.6823 32.7989 15.7009C34.9571 17.8912 36.162 20.846 36.1508 23.921C36.1395 26.996 34.9131 29.9418 32.7389 32.1163Z"
              fill="white"
            />
            <path
              id="Vector_2"
              d="M32.3303 28.7154C31.7658 29.6045 30.8739 30.6927 29.753 30.9627C27.7894 31.4372 24.7758 30.979 21.0258 27.4827L20.9794 27.4418C17.6821 24.3845 16.8258 21.84 17.033 19.8218C17.1476 18.6763 18.1021 17.64 18.9067 16.9636C19.0339 16.855 19.1847 16.7777 19.3471 16.7379C19.5095 16.6981 19.679 16.6968 19.842 16.7341C20.005 16.7715 20.157 16.8465 20.2858 16.9531C20.4146 17.0597 20.5167 17.195 20.5839 17.3481L21.7976 20.0754C21.8764 20.2522 21.9057 20.4472 21.8821 20.6394C21.8586 20.8316 21.7832 21.0137 21.6639 21.1663L21.0503 21.9627C20.9186 22.1271 20.8392 22.3272 20.8222 22.5372C20.8052 22.7471 20.8514 22.9574 20.9549 23.1409C21.2985 23.7436 22.1221 24.63 23.0358 25.4509C24.0612 26.3781 25.1985 27.2263 25.9185 27.5154C26.1111 27.5941 26.323 27.6133 26.5266 27.5705C26.7303 27.5278 26.9165 27.425 27.0612 27.2754L27.773 26.5581C27.9104 26.4227 28.0812 26.3261 28.268 26.2782C28.4549 26.2303 28.6511 26.2328 28.8367 26.2854L31.7194 27.1036C31.8784 27.1524 32.0242 27.2369 32.1455 27.3506C32.2669 27.4644 32.3606 27.6044 32.4196 27.7599C32.4785 27.9154 32.5011 28.0824 32.4856 28.248C32.4702 28.4136 32.417 28.5735 32.3303 28.7154Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default WhatsAppSVG;
